import Banner from "../../components/layout/banner";
import { useWindowDimensions } from "../../utils/utils";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  useCallback,
  useEffect,
  useRef,
  useState,
  lazy,
  Suspense,
} from "react";
import {
  DeliveryDiningSharp,
  ChevronLeft,
  ChevronRight,
  WhatsApp,
  CallSharp,
  Close,
  Fullscreen,
  FullscreenExit,
} from "@mui/icons-material";
import { RootState } from "../../app/store";
import { formatMoney } from "../../utils/format";
import Button from "../../components/form/button";
import Modal from "../../components/common/modal";
import Transaction from "../../components/ux/transaction";
import Validation from "../../components/ux/order-validation";
import {
  dismissValidationModal,
  toggleTransactionModal,
  dismissTransactionModal,
  toggleValidationModal,
} from "../../features/payments/paymentsSlice";
import { useQuery } from "@apollo/client";
import { PRODUCT, PRODUCTS_BY_IDS } from "../../api/product/queries";
import { CommentSection } from "./comment";
import {
  dismissUpSalesModal,
  toggleUpSalesModal,
} from "../../features/products/productsSlice";
import UpSell from "../../components/ux/upsell";
import Header from "../../components/layout/header";
import FloatingButton from "../../components/common/floating-button";
import LazyMultilingualAudioPlayer from "../../components/common/lazy-multilingual-audio-player";
import audioTrackWo from "../../assets/tracks/attote-wo.m4a";

const LazyVideoSlide = lazy(() => import("../../components/common/VideoSlide"));

interface Props {}

// Helper function to calculate the selling price based on quantity
const getSellingPrice = (basePrice, quantity, priceForTwo, priceForThree) => {
  switch (quantity) {
    case 1:
      return basePrice;
    case 2:
      return priceForTwo;
    case 3:
      return priceForThree;
    default:
      // For quantities greater than 3, apply a general discount or calculate based on base price
      // Based on your original code, it was basePrice * quantity - 1000 * quantity
      return basePrice * quantity - 1000 * quantity;
  }
};

function ATTOTE(props: Props) {
  const dispatch = useAppDispatch();
  const { data, loading, error } = useQuery(PRODUCT, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    errorPolicy: "all",
    variables: {
      productId: "6429962817f015be43b52b1b",
    },
  });
  const { width } = useWindowDimensions();
  const [state, setState] = useState({
    loaded: false,
    quantity: 1,
    lineClamp: false, // Changed to false to make it open by default
    showMoreOrLess: "Voir Moins", // Changed to "Voir Moins" to match open state
    product: {
      _id: "6429962817f015be43b52b1b",
      shop: {
        _id: "63d12a74fe7b1e352d970f18",
      },
      name: "ATTOTE ORIGINAL",
      price: 7000,
      previousPrice: 10000,
      price_for_two: 13000,
      price_for_three: 18000,
      selling_for: 7000, // Initial selling price for quantity 1
      uri: "https://vertus-organic.web.app/attote",
    },
  });

  let first = 50;

  const {
    data: products,
    fetchMore,
    networkStatus,
    refetch,
  } = useQuery(PRODUCTS_BY_IDS, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    errorPolicy: "all",
    variables: {
      first,
      productIds: [
        "6429948d17f015be43b52af1",
        "67e13ac7cb9c3dd784e8cc01",
        "689688cd74c5a7be0001929e",
        "6a71f32b3684d4971acfb615",
      ],
    },
  });
  const inputRef = useRef<HTMLInputElement>(null);
  const slideIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const isValidationModalOpen = useAppSelector(
    (state: RootState) => state.payments.isValidationModalOpen
  );

  const upSalesModalIsOpen = useAppSelector(
    (state: RootState) => state.products.product.upSalesModalIsOpen
  );

  const isTransactionModalOpen = useAppSelector(
    (state: RootState) => state.payments.isTransactionModalOpen
  );

  const images = [
    "https://newhackerway.blob.core.windows.net/images/01.png?sp=r&st=2025-07-02T22:58:07Z&se=2029-01-01T06:58:07Z&sv=2024-11-04&sr=b&sig=bRELrj3CQ%2FoOupEHU713CQdK3h%2BPNMt%2Fg1mYGZEcey0%3D",
    "https://newhackerway.blob.core.windows.net/images/03.png?sp=r&st=2025-07-02T23:00:54Z&se=2029-01-01T07:00:54Z&sv=2024-11-04&sr=b&sig=ukJUY%2BdUTclT%2BDpEtSC5KCR0V%2BKwiBb0h%2Bc5HzM3%2BzI%3D",
    "https://newhackerway.blob.core.windows.net/images/Attote/04%20-%20bis.png?sp=r&st=2025-08-15T12:15:43Z&se=2029-08-15T20:30:43Z&sv=2024-11-04&sr=b&sig=O0hkE%2FIaueOOnP2YcOciFjGyzzO%2FrM6goZyK8xvwShk%3D",
    "https://newhackerway.blob.core.windows.net/images/Attote/18%20-%20bis.png?sp=r&st=2025-08-15T12:35:57Z&se=2029-08-15T20:50:57Z&sv=2024-11-04&sr=b&sig=18jgDz82DSzA0yCkvQlot7%2BbRXI1Qc1iQ0dgiwyXRzQ%3D",
    "https://newhackerway.blob.core.windows.net/images/07.png?sp=r&st=2025-07-02T23:03:13Z&se=2029-01-01T07:03:13Z&sv=2024-11-04&sr=b&sig=8IjawqcSAWP3tZdpr0IM%2BOoLPskEDy6l%2BIPKUJptYRs%3D",
    "https://newhackerway.blob.core.windows.net/images/Attote/20250707_100528_0006%20-%20bis.png?sp=r&st=2025-08-15T13:00:42Z&se=2029-08-15T21:15:42Z&sv=2024-11-04&sr=b&sig=A7%2FJY1IIFOsHK5V1YTZ2yP74hO3MxM%2Bb2QbfJG%2BkSlc%3D",
    "https://newhackerway.blob.core.windows.net/images/Attote/20250707_100528_0004%20-%20bis.png?sp=r&st=2025-08-15T13:01:37Z&se=2029-08-15T21:16:37Z&sv=2024-11-04&sr=b&sig=bKWAS%2FqZ5Lwlbaw0wGiUth0wcYKNN48Q5TA7%2BXtRS98%3D",
    "https://newhackerway.blob.core.windows.net/images/Attote/20250707_100528_0005%20-%20bis.png?sp=r&st=2025-08-15T14:56:03Z&se=2029-08-15T23:11:03Z&sv=2024-11-04&sr=b&sig=KHn%2B4vUNFidYmLhmvF2W66YPvfe1z4nmva3ZS5Mb9sQ%3D",
    "https://newhackerway.blob.core.windows.net/images/Attote/16%20-%20bis.png?sp=r&st=2025-08-15T13:03:00Z&se=2029-08-15T21:18:00Z&sv=2024-11-04&sr=b&sig=V%2F0938LH6nwlC7Ejs8oPg7zHPz1HYDY9b51bw0%2BMCOI%3D",
    "https://newhackerway.blob.core.windows.net/images/Attote/Attote%20%20Usage.png?sp=r&st=2025-11-24T12:10:49Z&se=2029-11-24T20:25:49Z&sv=2024-11-04&sr=b&sig=SmYfWLyijqjbcqtKHRPk%2B2bOiBBpHLgoHGGTkfRS6CE%3D",
    "https://newhackerway.blob.core.windows.net/images/Attote/6%20%20-%20bis.png?sp=r&st=2025-08-15T13:03:48Z&se=2029-08-15T21:18:48Z&sv=2024-11-04&sr=b&sig=JRu0C7rcVxDTIZ8hxkUoKwoO63Mz%2F%2FFJpt0yV9urhYw%3D",
  ];

  // Vidéo en dernière position du carousel (MP4). Mettre une URL valide (SAS non expirée ou blob public).
  // Ex. Azure: générer une nouvelle SAS dans le portail ou utiliser un conteneur en lecture publique.
  const carouselVideoUrl =
    "https://newhackerway.blob.core.windows.net/images/Attote/Attote%20-%20Vid%C3%A9o%201080%20%C3%97%201920%20%20!.mp4?sp=r&st=2026-03-15T17:59:43Z&se=2029-03-16T02:14:43Z&sv=2024-11-04&sr=b&sig=Ra4%2F0wmskS5FY%2FBqyzK6KjpPqawOQMheaddb1%2Fi2tqA%3D";
  const carouselVideoPosterUrl = images?.[0] ?? undefined;
  const hasVideo = Boolean(carouselVideoUrl);
  const totalSlides = (images?.length ?? 0) + (hasVideo ? 1 : 0);
  const videoSlideIndex = images?.length ?? 0;
  const videoRef = useRef<HTMLVideoElement>(null);
  const fullscreenVideoRef = useRef<HTMLVideoElement>(null);
  const videoContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [data?.product?._id]);

  // Removed handleOnBlur and handleOnFocus as they were not directly related to quantity logic
  // and inputRef is not used in the provided JSX for quantity input.

  // Centralized function to update quantity and selling price
  const updateQuantityAndPrice = (newQuantity) => {
    setState((prevState) => {
      // Ensure quantity doesn't go below 1
      const effectiveQuantity = Math.max(1, newQuantity);

      const newSellingFor = getSellingPrice(
        prevState.product.price,
        effectiveQuantity,
        prevState.product.price_for_two,
        prevState.product.price_for_three
      );

      return {
        ...prevState,
        quantity: effectiveQuantity,
        product: {
          ...prevState.product,
          selling_for: newSellingFor,
        },
      };
    });
  };

  const handleSetQuantity = (quantity) => {
    updateQuantityAndPrice(quantity);
  };

  const handleDecreaseQuantity = () => {
    updateQuantityAndPrice(state.quantity - 1);
  };

  const handleIncreaseQuantity = () => {
    updateQuantityAndPrice(state.quantity + 1);
  };

  const handleSubmit = (e: any) => {
    dispatch(toggleValidationModal());
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isFullscreenVideoPlaying, setIsFullscreenVideoPlaying] =
    useState(false);
  const [videoLoadError, setVideoLoadError] = useState(false);
  const [videoRetryCount, setVideoRetryCount] = useState(0);
  const slideRef = useRef<HTMLDivElement>(null);
  const touchStartX = useRef<number>(0);
  const touchEndX = useRef<number>(0);

  const isVideoSlide = hasVideo && currentIndex === videoSlideIndex;

  useEffect(() => {
    setVideoLoadError(false);
    setVideoRetryCount(0);
  }, [carouselVideoUrl]);

  useEffect(() => {
    if (!isVideoSlide && videoRef.current) {
      videoRef.current.pause();
    }
  }, [currentIndex, isVideoSlide]);

  useEffect(() => {
    if (!isFullscreen || !isVideoSlide) {
      fullscreenVideoRef.current?.pause();
    }
  }, [isFullscreen, isVideoSlide, currentIndex]);

  const handleChevronLeft = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + totalSlides - 1) % totalSlides);
  }, [totalSlides]);

  const handleChevronRight = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
  }, [totalSlides]);

  const pauseSlider = useCallback(() => {
    if (slideIntervalRef.current) {
      clearInterval(slideIntervalRef.current);
      slideIntervalRef.current = null;
    }
  }, []);

  const startSlider = useCallback(() => {
    pauseSlider();
    slideIntervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        if (hasVideo && prevIndex === videoSlideIndex) return prevIndex;
        return (prevIndex + 1) % totalSlides;
      });
    }, 5000);
  }, [totalSlides, hasVideo, videoSlideIndex, pauseSlider]);

  // Touch handlers for mobile swipe
  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  }, []);

  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  }, []);

  const handleTouchEnd = useCallback(
    (e: React.TouchEvent) => {
      const touch = e.changedTouches?.[0];
      if (touch && videoContainerRef.current?.contains(touch.target as Node)) {
        return;
      }
      const swipeThreshold = 50;
      const diff = touchStartX.current - touchEndX.current;
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          handleChevronRight();
        } else {
          handleChevronLeft();
        }
      }
    },
    [handleChevronLeft, handleChevronRight]
  );

  // Keyboard navigation
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") {
        handleChevronLeft();
      } else if (e.key === "ArrowRight") {
        handleChevronRight();
      } else if (e.key === "Escape" && isFullscreen) {
        setIsFullscreen(false);
      }
    },
    [handleChevronLeft, handleChevronRight, isFullscreen]
  );

  useEffect(() => {
    startSlider();

    if (slideRef.current) {
      slideRef.current.addEventListener("mouseenter", pauseSlider);
      slideRef.current.addEventListener("mouseleave", startSlider);
    }

    // Add keyboard event listener
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      pauseSlider();
      if (slideRef.current) {
        slideRef.current.removeEventListener("mouseenter", pauseSlider);
        slideRef.current.removeEventListener("mouseleave", startSlider);
      }
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [startSlider, pauseSlider, handleKeyDown]);

  const toggleLineClamp = () => {
    setState((prevState) => ({
      ...prevState,
      lineClamp: !prevState.lineClamp,
      // Corrected logic: if lineClamp is now TRUE (clamped), show "Voir Plus".
      // If lineClamp is now FALSE (not clamped), show "Voir Moins".
      showMoreOrLess: !prevState.lineClamp ? "Voir Plus" : "Voir Moins",
    }));
  };

  const toggleFullscreen = useCallback(() => {
    setIsFullscreen((prev) => !prev);
  }, []);

  const slideContentStyle = {
    width: "100%",
    maxHeight: "80vh",
    minWidth: "0",
    objectFit: "cover" as const,
  };

  const ImageGridItem = () => {
    if (hasVideo && currentIndex === videoSlideIndex) {
      return (
        <Suspense
          fallback={
            <div
              className="flex items-center justify-center bg-gray-100 rounded-lg"
              style={slideContentStyle}
            >
              <span className="text-gray-500 text-sm">
                Chargement de la vidéo…
              </span>
            </div>
          }
        >
          <LazyVideoSlide
            videoContainerRef={videoContainerRef}
            videoRef={videoRef}
            videoUrl={carouselVideoUrl}
            posterUrl={carouselVideoPosterUrl}
            videoLoadError={videoLoadError}
            setVideoLoadError={setVideoLoadError}
            videoRetryCount={videoRetryCount}
            setVideoRetryCount={setVideoRetryCount}
            isVideoPlaying={isVideoPlaying}
            setIsVideoPlaying={setIsVideoPlaying}
            toggleFullscreen={toggleFullscreen}
            slideContentStyle={slideContentStyle}
            ariaLabel={`Vidéo de présentation du produit ${
              state?.product?.name ?? ""
            }`}
          />
        </Suspense>
      );
    }
    return (
      <div className="relative">
        <img
          onLoad={() => {
            setState((prevState) => ({
              ...prevState,
              loaded: true,
            }));
          }}
          src={images[currentIndex]}
          loading="lazy"
          alt={`${state?.product?.name} - Image ${
            currentIndex + 1
          } sur ${totalSlides}`}
          style={slideContentStyle}
          role="img"
          aria-label={`Image ${currentIndex + 1} de ${totalSlides} du produit ${
            state?.product?.name
          }`}
          onContextMenu={(e) => e.preventDefault()}
        />
        <button
          onClick={toggleFullscreen}
          className="absolute bottom-2 right-2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-2 transition-all"
          aria-label="Afficher en plein écran"
          title="Afficher en plein écran (Cliquer sur l'image)"
        >
          <Fullscreen />
        </button>
      </div>
    );
  };

  // Fullscreen Modal Component
  const FullscreenModal = () => {
    if (!isFullscreen) return null;

    return (
      <div
        className="fixed inset-0 z-[9999] bg-black bg-opacity-95 flex items-center justify-center"
        onClick={toggleFullscreen}
        role="dialog"
        aria-modal="true"
        aria-label="Visualisation en plein écran"
      >
        <div className="relative w-full h-full flex items-center justify-center">
          {/* Close Button */}
          <button
            onClick={toggleFullscreen}
            className="absolute top-4 right-4 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-2 z-10 transition-all"
            aria-label="Fermer le plein écran (Échap)"
            title="Fermer (Échap)"
          >
            <Close fontSize="large" onClick={toggleFullscreen} />
          </button>

          {/* Navigation Buttons */}
          {totalSlides > 1 && (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleChevronLeft();
                }}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-3 z-10 transition-all"
                aria-label="Image précédente"
                title="Image précédente (Flèche gauche)"
              >
                <ChevronLeft fontSize="large" />
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleChevronRight();
                }}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-3 z-10 transition-all"
                aria-label="Image suivante"
                title="Image suivante (Flèche droite)"
              >
                <ChevronRight fontSize="large" />
              </button>
            </>
          )}

          {/* Main content: image or video */}
          {isVideoSlide ? (
            videoLoadError ? (
              <div className="flex flex-col items-center justify-center text-center p-6 max-w-md">
                {carouselVideoPosterUrl && (
                  <img
                    src={carouselVideoPosterUrl}
                    alt=""
                    className="w-full rounded-lg object-contain opacity-70"
                  />
                )}
                <p className="mt-4 text-white font-medium">
                  Vidéo non disponible
                </p>
                <p className="mt-1 text-white/80 text-sm">
                  Format non supporté ou erreur réseau. Réessayez.
                </p>
                <button
                  type="button"
                  onClick={() => {
                    setVideoLoadError(false);
                    setVideoRetryCount((c) => c + 1);
                  }}
                  className="mt-4 px-4 py-2 bg-white text-gray-900 rounded-lg text-sm font-medium hover:bg-gray-100"
                >
                  Réessayer
                </button>
              </div>
            ) : (
              <>
                <video
                  ref={fullscreenVideoRef}
                  key={`fullscreen-${carouselVideoUrl}-${videoRetryCount}`}
                  poster={carouselVideoPosterUrl}
                  preload="metadata"
                  playsInline
                  controls
                  controlsList="nodownload"
                  className="max-w-full max-h-full object-contain cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (fullscreenVideoRef.current?.paused)
                      fullscreenVideoRef.current.play().catch(() => {});
                  }}
                  onPlay={() => setIsFullscreenVideoPlaying(true)}
                  onPause={() => setIsFullscreenVideoPlaying(false)}
                  onEnded={() => setIsFullscreenVideoPlaying(false)}
                  onContextMenu={(e) => e.preventDefault()}
                  onError={() => setVideoLoadError(true)}
                >
                  <source src={carouselVideoUrl} type="video/mp4" />
                </video>
                {!isFullscreenVideoPlaying && (
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        const video = fullscreenVideoRef.current;
                        if (video) video.play().catch(() => {});
                      }}
                      className="pointer-events-auto flex h-20 w-20 items-center justify-center rounded-full bg-white/90 shadow-lg hover:scale-105 hover:bg-white"
                      aria-label="Lire la vidéo"
                    >
                      <svg
                        className="ml-1 h-10 w-10 text-gray-800"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </button>
                  </div>
                )}
              </>
            )
          ) : (
            <img
              src={images[currentIndex]}
              alt={`${state?.product?.name} - Image ${
                currentIndex + 1
              } sur ${totalSlides}`}
              className="max-w-full max-h-full object-contain"
              onClick={(e) => e.stopPropagation()}
              onContextMenu={(e) => e.preventDefault()}
            />
          )}

          {/* Image Counter */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-white bg-opacity-75 px-4 py-2 rounded-full z-10">
            <span className="font-semibold">
              {currentIndex + 1} / {totalSlides}
            </span>
          </div>

          {/* Thumbnails in fullscreen */}
          {totalSlides > 1 && (
            <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 flex gap-1 overflow-x-auto min-w-[70vw] max-w-[90vw] scrollbar-hide">
              {images.map((img, i) => (
                <button
                  key={i}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentIndex(i);
                  }}
                  className={`flex-shrink-0 border-2 rounded transition-all ${
                    currentIndex === i
                      ? "border-white ring-2 ring-white"
                      : "border-transparent opacity-60 hover:opacity-100"
                  }`}
                >
                  <img
                    src={img}
                    alt={`Miniature ${i + 1}`}
                    className="w-16 h-16 object-cover rounded"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </button>
              ))}
              {hasVideo && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentIndex(videoSlideIndex);
                  }}
                  className={`flex-shrink-0 border-2 rounded transition-all relative ${
                    currentIndex === videoSlideIndex
                      ? "border-white ring-2 ring-white"
                      : "border-transparent opacity-60 hover:opacity-100"
                  }`}
                  aria-label="Vidéo"
                >
                  <img
                    src={carouselVideoPosterUrl}
                    alt="Vidéo"
                    className="w-16 h-16 object-cover rounded"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                  <span className="absolute inset-0 flex items-center justify-center rounded bg-black/30">
                    <svg
                      className="h-6 w-6 text-white"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </span>
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Fullscreen Image Viewer */}
      <FullscreenModal />

      <Modal
        modalIsOpen={upSalesModalIsOpen}
        className="w-11/12 md:w-3/5"
        dismissModal={() => dispatch(dismissUpSalesModal())}
        handleModal={() => dispatch(toggleUpSalesModal())}
        content={<UpSell products={products?.productsByIds?.page?.edges} />}
      />
      <Modal
        modalIsOpen={isValidationModalOpen}
        className="w-11/12 md:w-3/12"
        dismissModal={() => dispatch(dismissValidationModal())}
        content={
          <Validation
            pixelId="2318743751858547"
            handleDismiss={() => dispatch(dismissValidationModal())}
            item={{ ...state.product, quantity: state.quantity }}
          />
        }
      />
      {/* The Grid */}
      <div
        className="mx-auto grid min-h-screen max-w"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gridTemplateRows: "5em auto",
        }}
      >
        {/* Header */}
        {/* Header Hack */}
        <div className="header"></div>
        <div className="fixed top-0 left-0 right-0 z-50 bg-white w-full">
          <Banner className="bg-djeliba" />
          <Header />
        </div>
        {/* Content */}
        <div
          style={{
            gridColumn: "1 / -1",
          }}
        >
          <div className="flex flex-col my-5 md:flex-row justify-around items-start">
            <div className="w-full md:w-1/3 border relative">
              <div
                ref={slideRef}
                className="w-full select-none relative"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                role="region"
                aria-label="Carousel d'images du produit"
                aria-live="polite"
              >
                <div className="w-full flex-row flex justify-evenly items-center">
                  <figure className="md:h-full grow md:m-2.5">
                    {ImageGridItem()}
                  </figure>
                </div>
                {totalSlides > 1 && (
                  <>
                    <div
                      className="absolute md:my-0 my-4 flex w-full md:flex-col md:w-1/6 md:h-full md:overflow-y-auto overflow-scroll scrollbar-hide md:-left-16 md:-top-1 md:px-3 justify-start items-center bg-transparent"
                      role="tablist"
                      aria-label="Miniatures des images et vidéo"
                    >
                      {images.map((item, i) => (
                        <button
                          key={i}
                          className={`border rounded md:my-1 hover:border-2 md:w-full min-w-14 mx-1 transition-all ${
                            currentIndex === i
                              ? "border-djeliba border-2 ring-2 ring-djeliba"
                              : "border-djeliba"
                          }`}
                          onClick={() => setCurrentIndex(i)}
                          onMouseEnter={() => setCurrentIndex(i)}
                          role="tab"
                          aria-selected={currentIndex === i}
                          aria-label={`Afficher image ${i + 1}`}
                          title={`Image ${i + 1}`}
                        >
                          <img
                            src={images[i]}
                            alt={`Miniature ${i + 1}`}
                            loading="lazy"
                            style={{
                              width: "100%",
                              maxHeight: "80vh",
                              minWidth: "0",
                              objectFit: "cover",
                            }}
                            onContextMenu={(e) => e.preventDefault()}
                          />
                        </button>
                      ))}
                      {hasVideo && (
                        <button
                          className={`border rounded md:my-1 hover:border-2 md:w-full min-w-14 mx-1 transition-all relative ${
                            currentIndex === videoSlideIndex
                              ? "border-djeliba border-2 ring-2 ring-djeliba"
                              : "border-djeliba"
                          }`}
                          onClick={() => setCurrentIndex(videoSlideIndex)}
                          onMouseEnter={() => setCurrentIndex(videoSlideIndex)}
                          role="tab"
                          aria-selected={currentIndex === videoSlideIndex}
                          aria-label="Afficher la vidéo"
                          title="Vidéo"
                        >
                          <img
                            src={carouselVideoPosterUrl}
                            alt="Vidéo"
                            loading="lazy"
                            style={{
                              width: "100%",
                              maxHeight: "80vh",
                              minWidth: "0",
                              objectFit: "cover",
                            }}
                            onContextMenu={(e) => e.preventDefault()}
                          />
                          <span className="absolute inset-0 flex items-center justify-center bg-black/20 rounded">
                            <svg
                              className="h-6 w-6 text-white drop-shadow"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M8 5v14l11-7z" />
                            </svg>
                          </span>
                        </button>
                      )}
                    </div>
                  </>
                )}
              </div>
              <div className="w-full px-1 flex justify-between items-center">
                <div className="flex max-w-min">
                  <a
                    className="text-green-500 top-0 right-1 m-1 p-0.5 rounded absolute"
                    target="_blank"
                    rel="noreferrer"
                    href={`tel:${221773808340}`}
                  >
                    <CallSharp
                      className="border rounded-md p-1 text-blue-500 bg-white"
                      fontSize="large"
                    />
                  </a>
                  <a
                    className="text-green-500 top-11 right-1 m-1 p-0.5 rounded absolute"
                    target="_blank"
                    rel="noreferrer"
                    href={`https://api.whatsapp.com/send?phone=${221773808340}&text=${encodeURIComponent(
                      "Je souhaite commander l'article : " +
                        state?.product?.name +
                        "\n\nLien : " +
                        state?.product?.uri
                    )}`}
                  >
                    <WhatsApp
                      className="border rounded-md text-green-500 bg-white"
                      fontSize="large"
                    />
                  </a>
                </div>
                {totalSlides > 1 && (
                  <div
                    className="flex w-full h-5 justify-center items-center"
                    role="group"
                    aria-label="Indicateurs de progression du carousel"
                  >
                    {images?.map((item, i) => (
                      <button
                        key={i}
                        onClick={() => setCurrentIndex(i)}
                        className={
                          currentIndex === i
                            ? "bg-black h-1.5 w-1.5 rounded-full ml-1 cursor-pointer hover:scale-150 transition-transform"
                            : "bg-slate-400 h-1 w-1.5 rounded-sm ml-1 cursor-pointer hover:bg-slate-600 transition-colors"
                        }
                        aria-label={`Aller à l'image ${i + 1}`}
                        aria-current={currentIndex === i ? "true" : "false"}
                        title={`Image ${i + 1}`}
                      ></button>
                    ))}
                    {hasVideo && (
                      <button
                        onClick={() => setCurrentIndex(videoSlideIndex)}
                        className={
                          currentIndex === videoSlideIndex
                            ? "bg-black h-1.5 w-1.5 rounded-full ml-1 cursor-pointer hover:scale-150 transition-transform"
                            : "bg-slate-400 h-1 w-1.5 rounded-sm ml-1 cursor-pointer hover:bg-slate-600 transition-colors"
                        }
                        aria-label="Aller à la vidéo"
                        aria-current={
                          currentIndex === videoSlideIndex ? "true" : "false"
                        }
                        title="Vidéo"
                      ></button>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="w-full mt-14 md:mt-0 md:w-1/2 h-full md:border hover:border-0">
              <div className="mx-2 my-3">
                  <LazyMultilingualAudioPlayer
                    tracks={{
                      wo: audioTrackWo,
                    }}
                    languageLabels={{
                      wo: "Wolof",
                      pl: "Pulaar",
                      fr: "Français",
                    }}
                  />
              </div>
              <div className="flex justify-around md:justify-between items-center mb-2 sticky">
                <div id="product-name-container">
                  <div className="m-2">
                    <span className="font-bold text-lg md:text-3xl">
                      {state?.product?.name}
                    </span>
                  </div>
                  <div className="m-2">
                    <span className="font-bold text-yellow-500 md:text-xl">
                      Livraison gratuite
                    </span>
                  </div>
                  <div className="m-2 my-3">
                    <div
                      className={
                        state.quantity === 1
                          ? "flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300 border-2 border-green-500"
                          : `flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300`
                      }
                      onClick={() => handleSetQuantity(1)}
                    >
                      <div className="h-12 w-12 mr-1">
                        <img
                          className="w-full rounded-md"
                          src="https://newhackerway.blob.core.windows.net/images/01.png?sp=r&st=2025-07-02T22:58:07Z&se=2029-01-01T06:58:07Z&sv=2024-11-04&sr=b&sig=bRELrj3CQ%2FoOupEHU713CQdK3h%2BPNMt%2Fg1mYGZEcey0%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="flex flex-col w-full items-end">
                        <div className="flex w-full justify-around">
                          🔥
                          <span>1</span>
                          <span>--&gt;</span>
                          <span className="font-thin">
                            {formatMoney.format(state?.product?.price)}
                          </span>
                        </div>
                        <div className="flex w-full justify-center">
                          <span className="flex justify-around w-full text-sm text-green-500">
                            <span className="line-through text-black">
                              {state.product.previousPrice}
                            </span>{" "}
                            Economisez{" "}
                            {formatMoney.format(
                              state.product.previousPrice - state.product.price
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        state.quantity === 2
                          ? "flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300 border-2 border-green-500"
                          : `flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300`
                      }
                      onClick={() => handleSetQuantity(2)}
                    >
                      <div className="h-12 w-12 mr-1">
                        <img
                          className="w-full rounded-md"
                          src="https://newhackerway.blob.core.windows.net/images/01.png?sp=r&st=2025-07-02T22:58:07Z&se=2029-01-01T06:58:07Z&sv=2024-11-04&sr=b&sig=bRELrj3CQ%2FoOupEHU713CQdK3h%2BPNMt%2Fg1mYGZEcey0%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="flex flex-col w-full items-end">
                        <div className="flex w-full justify-around">
                          🔥🔥
                          <span>2</span>
                          <span>--&gt;</span>
                          <span className="font-thin">
                            {formatMoney.format(state?.product?.price_for_two)}{" "}
                          </span>
                        </div>
                        <div className="flex w-full justify-center">
                          <span className="flex justify-around w-full text-sm text-green-500">
                            <span className="line-through text-black">
                              {state.product.previousPrice * 2}
                            </span>{" "}
                            Economisez{" "}
                            {formatMoney.format(
                              state.product.previousPrice * 2 -
                                state.product.price_for_two
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        state.quantity === 3
                          ? "flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300 border-2 border-green-500"
                          : `flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300`
                      }
                      onClick={() => handleSetQuantity(3)}
                    >
                      <div className="h-12 w-12 mr-1">
                        <img
                          className="w-full rounded-md"
                          src="https://newhackerway.blob.core.windows.net/images/01.png?sp=r&st=2025-07-02T22:58:07Z&se=2029-01-01T06:58:07Z&sv=2024-11-04&sr=b&sig=bRELrj3CQ%2FoOupEHU713CQdK3h%2BPNMt%2Fg1mYGZEcey0%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="flex flex-col w-full items-end">
                        <div className="flex w-full justify-around">
                          🔥🔥🔥
                          <span>3</span>
                          <span>--&gt;</span>
                          <span className="font-thin">
                            {formatMoney.format(
                              state?.product?.price_for_three
                            )}{" "}
                          </span>
                        </div>
                        <div className="flex w-full justify-center">
                          <span className="flex justify-around w-full text-sm text-green-500">
                            <span className="line-through text-black">
                              {state.product.previousPrice * 3}
                            </span>{" "}
                            Economisez{" "}
                            {formatMoney.format(
                              state.product.previousPrice * 3 -
                                state.product.price_for_three
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex-col justify-evenly items-center">
                  <div className="flex justify-center items-center">
                    <span
                      onClick={handleDecreaseQuantity}
                      className="font-bold rounded-md px-2 mx-1 hover:cursor-pointer border-2 hover:border-black bg-djeliba text-xl"
                    >
                      -
                    </span>
                    <span className="font-bold rounded-sm px-1 mx-1 bg-black text-white text-lg">
                      {state.quantity}
                    </span>
                    <span
                      onClick={handleIncreaseQuantity}
                      className="font-bold rounded-md px-2 mx-1 hover:cursor-pointer border-2 hover:border-green-500 bg-djeliba text-xl"
                    >
                      +
                    </span>
                  </div>
                  <div className="px-2">
                    <Button
                      title="Commander"
                      isWaiting={false}
                      handleOnClick={(e) => handleSubmit(e)}
                      disabled={false}
                      className="hover:shadow-2xl cursor-pointer hover:transition-all ease-linear duration-300"
                    />
                  </div>
                </div>
              </div>

              <div className="mx-2">
                {state.lineClamp ? (
                  <p
                    className="border-none w-full outline-none text-sm px-2 py-1 rounded-md ml-1"
                    style={{
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 1,
                      overflow: "hidden",
                    }}
                    onClick={toggleLineClamp}
                  >
                    ATTOTE ORIGINAL APHRODISIAQUE 100% NATUREL POUR : Diabète,
                    Tension, Vision floue, Maux de ventre, Fièvre, Fatigue
                    générale, Faiblesse Sexuelles, Sinusite, Ulcère, Règle
                    douloureuse, Perte Blanche, Insomnie, Maux de rein,
                    Hémorroïde, Ballonnement de Ventre, Constipation,
                    etc...Posologie: Boire 1/2 verre de thé le matin après le
                    repas et 1/2 verre de thé le soir après le repas pour le
                    traitement. Mais pour un effet immediat avant rapport
                    prendre 2 verres de thé une heure de temps avant rapport.
                  </p>
                ) : (
                  <div className="flex-row" onClick={toggleLineClamp}>
                    <p className="">
                      Découvrez ATTOTE ORIGINAL, un puissant élixir 100% naturel
                      issu de la pharmacopée africaine traditionnelle, formulé
                      pour restaurer l’équilibre du corps et améliorer
                      significativement votre qualité de vie. Véritable
                      concentré de bienfaits, ATTOTE agit efficacement sur une
                      large gamme de troubles et inconforts quotidiens, grâce à
                      ses ingrédients naturels soigneusement sélectionnés.
                    </p>
                    <div className="m-1">
                      <h2 className="text-lg">🎯 À qui est destiné ATTOTE ?</h2>
                      ATTOTE s’adresse à toutes celles et ceux qui souhaitent
                      retrouver énergie, vitalité et bien-être au naturel. Il
                      est particulièrement recommandé pour :
                      <ul className="list-disc ml-6">
                        <li>
                          Les hommes souffrant de faiblesse sexuelle ou désirant
                          améliorer leurs performances et leur endurance
                        </li>
                        <li>
                          Les personnes atteintes de diabète ou d’hypertension
                          cherchant à mieux réguler leur glycémie et leur
                          tension
                        </li>
                        <li>
                          Celles et ceux qui connaissent une vision floue ou une
                          baisse de clarté visuelle
                        </li>
                        <li>
                          Les personnes sujettes aux douleurs abdominales, à la
                          fatigue chronique ou à des fièvres récurrentes
                        </li>
                        <li>
                          Les femmes souffrant de règles douloureuses, de pertes
                          blanches ou de troubles du sommeil
                        </li>
                        <li>
                          Les personnes ayant des problèmes tels que ulcères,
                          sinusites, hémorroïdes, ballonnements, constipation ou
                          douleurs rénales
                        </li>
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          src="https://newhackerway.blob.core.windows.net/images/Attote/6.png?sp=r&st=2025-08-14T15:33:18Z&se=2029-08-14T23:48:18Z&sv=2024-11-04&sr=b&sig=VRKJ1QXqBMSm7POjQZknUjGxqiV2DWuZpxG7owp6IGI%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="m-1">
                      <h2 className="text-lg">
                        ✅ Ses vertus thérapeutiques :
                      </h2>
                      ATTOTE est reconnu pour ses propriétés aphrodisiaques
                      puissantes, mais ce n’est pas tout. Il est également
                      recommandé pour :
                      <ul className="list-disc ml-6">
                        <li>
                          Réguler la glycémie et la tension artérielle (idéal
                          pour les personnes souffrant de diabète ou
                          d’hypertension)
                        </li>
                        <li>
                          Améliorer la clarté visuelle en cas de vision floue
                        </li>
                        <li>
                          Soulager les douleurs abdominales, fièvres et fatigues
                          chroniques
                        </li>
                        <li>
                          Combattre la faiblesse sexuelle et améliorer
                          l’endurance
                        </li>
                        <li>
                          Apaiser les douleurs liées aux règles, les pertes
                          blanches et les troubles du sommeil
                        </li>
                        <li>
                          Traiter les ulcères, sinusites, hémorroïdes,
                          ballonnements, constipations et douleurs rénales
                        </li>
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          src="https://newhackerway.blob.core.windows.net/images/Attote/20250707_100528_0001.png?sp=r&st=2025-07-07T17:59:27Z&se=2029-07-08T01:59:27Z&sv=2024-11-04&sr=b&sig=M91oQvOJYZIJj%2BztK3lHEXhVdvg3our1sNLI3O88RHg%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="m-1">
                      <h2 className="text-lg">📌 Posologie conseillée :</h2>
                      <ul className="list-disc ml-6">
                        <li>
                          Traitement quotidien : Boire 1/2 verre de thé le matin
                          après le repas et 1/2 verre le soir après le dîner.
                        </li>
                        <li>
                          Effet immédiat avant rapport sexuel : Prendre 2 verres
                          une heure avant le rapport pour un regain d’énergie et
                          de performance.
                        </li>
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          src="https://newhackerway.blob.core.windows.net/images/Attote/20250707_100528_0000.png?sp=r&st=2025-07-07T18:07:06Z&se=2029-07-08T02:07:06Z&sv=2024-11-04&sr=b&sig=jk4G5hwfeYmLn4Hpwwdd4053FSMshmeC0NE3ExY1G%2Fg%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="m-1">
                      <h2 className="text-lg">
                        🌿 100% Naturel – Sans effets secondaires
                      </h2>
                      <ul className="list-disc ml-6">
                        <li>
                          Sans conservateurs ni produits chimiques, ATTOTE
                          ORIGINAL est une solution naturelle et sûre pour un
                          usage régulier.
                        </li>
                        <li>
                          Redonnez à votre corps toute sa puissance naturelle
                          avec ATTOTE ! Un allié incontournable pour rester
                          fort, endurant et en pleine forme à tout âge.
                        </li>
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          src="https://newhackerway.blob.core.windows.net/images/Attote/37.png?sp=r&st=2025-11-24T12:12:31Z&se=2029-11-24T20:27:31Z&sv=2024-11-04&sr=b&sig=CD31fCQ%2Fs1RkRDPr0QktY7cY6Z2%2FF6ltFrQ0ylT4rPY%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <span
                  className="text-sm font-thin text-gray-400 cursor-pointer"
                  onClick={toggleLineClamp}
                >
                  {state.showMoreOrLess}
                </span>
              </div>

              <div className="flex-col w-full mt-2 md:mt-0 h-full overflow-hidden">
                {/* Integrate the CommentSection component */}
                <CommentSection />
              </div>
            </div>
          </div>
        </div>

        {/* Recommendation */}
        <div
          className="p-0 my-2"
          style={{
            gridColumn: "1 / -1",
          }}
        >
          {/* <>
            <div className="flex justify-start md:justify-center items-center m-2 p-1">
              <span className="font-bold text-xl">
                D'autres produits de{" "}
                <span className="text-yellow-500">{data?.product?.shop?.name}</span>
              </span>
            </div>
            <Slider
              images={data?.productsByShop.page.edges?.map(
                (item) => item?.node?.images[0]?.lg
              )}
            />
          </> */}
        </div>

        {/* Footer */}

        {/* Bouton flottant pour remonter en haut */}
        <FloatingButton targetSelector="#product-name-container" />
      </div>
    </>
  );
}

export default ATTOTE;
